'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherLock } from '@subframe/core';
import type { PortaDosAutos } from '../../types/baixarProcesso.types';
interface EtapaSemAcessoProps {
  motivo: 'semPermissao' | 'indisponivel';
  porta: PortaDosAutos;
}
type Texto = {
  titulo: string;
  detalhe: string;
};

// Quem está na porta da Secretaria não pertence ao escritório do processo: pedir acesso "a quem
// administra o escritório" mandaria a pessoa ao lugar errado.
const SEM_PERMISSAO: Record<PortaDosAutos, Texto> = {
  escritorio: {
    titulo: 'Você não tem permissão para baixar este processo',
    detalhe: 'Baixar os autos exige acesso de consulta aos processos arbitrais. Peça esse acesso a quem administra o escritório.'
  },
  secretaria: {
    titulo: 'Você não tem permissão para baixar este processo',
    detalhe: 'Baixar os autos pela Secretaria exige o perfil de Secretaria ou de administração da Arbitralis.'
  }
};
const TEXTOS: Record<Exclude<EtapaSemAcessoProps['motivo'], 'semPermissao'>, Texto> = {
  indisponivel: {
    titulo: 'O download dos autos ainda não está disponível',
    detalhe: 'O recurso ainda não foi liberado para o escritório deste processo. Nada foi gerado.'
  }
};

/**
 * Recusa do servidor — não há o que tentar de novo. Estado sem mock: reaproveita o cartão
 * informativo do segundo plano, e o título diz o motivo em texto, não só pela cor.
 */
export function EtapaSemAcesso(t0) {
  const $ = _c(8);
  const {
    motivo,
    porta
  } = t0;
  const texto = motivo === "semPermissao" ? SEM_PERMISSAO[porta] : TEXTOS[motivo];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherLock className="text-info-700 mt-px h-[17px] w-[17px] flex-none" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== texto.titulo) {
    t2 = <span className="text-info-700 text-[13.5px] font-semibold">{texto.titulo}</span>;
    $[1] = texto.titulo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== texto.detalhe) {
    t3 = <span className="text-info-700 text-[12.5px] leading-[1.6]">{texto.detalhe}</span>;
    $[3] = texto.detalhe;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="flex w-full flex-col gap-4 px-6 pt-1 pb-6"><div className="border-info-200 bg-info-50 flex items-start gap-3 rounded-[12px] border border-solid px-[18px] py-4" role="status">{t1}<div className="flex flex-col gap-[3px]">{t2}{t3}</div></div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}